const { defineAbilitiesForUser } = require("./define-abilities");
const { subject } = require("@casl/ability");

const can = (user, action, subjectType, subjectInstance = null) => {
  const ability = defineAbilitiesForUser(user);
  return subjectInstance
    ? ability.can(action, subject(subjectType, subjectInstance))
    : ability.can(action, subjectType);
};

module.exports = {
  can,
};
